// Base path for the CMS API. In dev, Vite proxies /cms to the local PHP server.
// In production (Hostinger), the cms/ folder lives alongside the site (same origin).
const CMS_BASE = '/cms/api';

export interface CmsPlan {
  id: number;
  name: { pt: string; en: string };
  price: string;
  perMonth: boolean;
  priceNote: { pt: string; en: string };
  description: { pt: string; en: string };
  highlighted: boolean;
}

export interface CmsPlansResponse {
  plans: CmsPlan[];
  passes: CmsPlan[];
}

/**
 * Fetches plans and passes from the CMS. Returns null if unreachable,
 * so callers can fall back to the bundled defaults.
 */
export async function fetchCmsPlans(): Promise<CmsPlansResponse | null> {
  try {
    const res = await fetch(`${CMS_BASE}/plans.php`);
    if (!res.ok) return null;
    const data: CmsPlansResponse = await res.json();
    if (!Array.isArray(data.plans) || !Array.isArray(data.passes)) return null;
    return data;
  } catch {
    return null;
  }
}
